import {APIService} from '@core/services/api.service';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SharingService {

  sharingRoute = 'share/';
  renderRoute = 'render/';

  public facebookSharingBaseURL = 'https://www.facebook.com/sharer/sharer.php?u=';

  constructor(private apiService: APIService,
              private http: HttpClient) {}

  fetchEventSharingInfo(eventid: string, teamid: string) {
    const url = this.getEventSharingRoute(eventid, teamid);
    return this.http.get(url, this.apiService.getJsonOptions())
      .toPromise()
      .then(response => this.resolveSharingInfo(response))
      .catch(this.handleError);
  }

  fetchEventRankingSharingInfo(eventid: string, teamid: string) {
    const url = this.getEventRankingSharingInfoRoute(eventid, teamid);
    return this.http.get(url, this.apiService.getJsonOptions())
      .toPromise()
      .then(response => this.resolveSharingInfo(response))
      .catch(this.handleError);
  }

  fetchEventLineupSharingInfo(eventid: string, teamid: string) {
    const url = this.getEventLineupSharingInfoRoute(eventid, teamid);
    return this.http.get(url, this.apiService.getJsonOptions())
      .toPromise()
      .then(response => this.resolveSharingInfo(response));
  }

  fetchNewsEntrySharingInfo(entryid: string) {
    const url = this.getNewsEntrySharingInfoRoute(entryid);
    return this.http.get(url, this.apiService.getJsonOptions())
      .toPromise()
      .then(response => this.resolveSharingInfo(response))
      .catch(this.handleError);
  }

  fetchVotingSharingInfo(votingid: string) {
    const url = this.getVotingSharingInfoRoute(votingid);
    return this.http.get(url, this.apiService.getJsonOptions())
      .toPromise()
      .then(response => this.resolveSharingInfo(response))
      .catch(this.handleError);
  }

  resolveSharingInfo(response) {
    return response.success ? response.data : response; // v2 routes return json with success flag, old ones deliver result data directly
  }

  getEventSharingRoute(eventid: string, teamid: string) {
    return this.apiService.getBaseURL() + this.sharingRoute + 'events/' + eventid + '?teamid=' + teamid;
  }

  getEventLineupSharingInfoRoute(eventid: string, teamid: string) {
    return this.apiService.getBaseURL() + this.sharingRoute + 'lineup/' + eventid + '/' + teamid;
  }

  getEventRankingSharingInfoRoute(eventid: string, teamid: string) {
    return this.apiService.getBaseURL() + this.sharingRoute + 'ranking/' + eventid + '/' + teamid;
  }

  getNewsEntrySharingInfoRoute(entryid: string) {
    return this.apiService.getBaseURL() + this.sharingRoute + 'news/' + entryid;
  }

  getVotingSharingInfoRoute(votingid: string) {
    return this.apiService.getBaseURL() + 'v2/' + this.sharingRoute + 'voting/' + votingid;
  }

  handleError(error) {
    console.log(error);
  }
}
